var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { createColumnHelper } from '@tanstack/react-table';
import RenderIfVisible from 'react-render-if-visible';
import { Translate } from "../../../../../I18N";

import { Button, Pill, Table } from "../../../../Components/UI";
import { FormInput } from "./FormInput";


















const LanguageHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Language");
const StatusHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Language Code");
const FieldKeyHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Value");
const LabelHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Name");
const TypeHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Type");
const ActionHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Action");

const RenderButton = ({ cell }) => /*#__PURE__*/
_jsx(Link, { to: `edit/${cell.row.original.id}` }, void 0, /*#__PURE__*/
_jsx(Button, { styling: "outline", className: "leading-4" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Translate")
)
);


const ContextPill = ({ cell }) => /*#__PURE__*/
_jsx("div", { className: "whitespace-nowrap" }, void 0, /*#__PURE__*/
_jsx(Pill, { color: "gray" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, cell.renderValue())
)
);


const LanguagePill = ({ cell }) => {var _cell$getValue$langua;
  let color = 'gray';
  if (cell.getValue().status === 'defaultLanguage') color = 'primary';
  if (cell.getValue().status === 'untranslated') color = 'yellow';

  return /*#__PURE__*/_jsx(Pill, { color: color }, void 0, (_cell$getValue$langua = cell.getValue().languageKey) === null || _cell$getValue$langua === void 0 ? void 0 : _cell$getValue$langua.toUpperCase());
};

const TranslationsTables = ({
  tablesData,
  register,
  setValue,
  submitting,
  getFieldState
}) => {
  const memoizedInput = useMemo(
    () => (data) => FormInput(data, { register, setValue, submitting, getFieldState }),
    [getFieldState, register, setValue, submitting]
  );

  const columnHelper = createColumnHelper();

  const columns = [
  columnHelper.accessor('language', {
    header: LanguageHeader,
    enableSorting: false
  }),

  columnHelper.accessor('translationStatus', {
    header: StatusHeader,
    cell: LanguagePill,
    enableSorting: false,
    meta: { headerClassName: 'sr-only invisible bg-gray-50' }
  }),
  columnHelper.accessor('fieldKey', {
    header: FieldKeyHeader,
    cell: memoizedInput,
    enableSorting: false,
    meta: { headerClassName: 'w-full' }
  })];


  return /*#__PURE__*/(
    React.createElement(React.Fragment, null,
    tablesData.map((data) => {
      if (data) {
        const [contextTerm] = Object.keys(data);
        return /*#__PURE__*/(
          _jsx("div", { className: "mt-4" }, contextTerm, /*#__PURE__*/
          _jsx(RenderIfVisible, { stayRendered: true }, void 0, /*#__PURE__*/
          _jsx(Table, { columns: columns, data: data[contextTerm], title: contextTerm })
          )
          ));

      }

      return undefined;
    })
    ));

};

export { RenderButton, ContextPill, TranslationsTables, LabelHeader, TypeHeader, ActionHeader };